// Enable Healthcare Brand Constants
export const BRAND = {
  colors: {
    primaryBlue: "#1B365D",
    popBlue: "#0071E3",
    white: "#FFFFFF",
    gradientBlueStart: "#1B365D",
    gradientBlueEnd: "#0071E3",
  },
  gradients: {
    primary: "linear-gradient(135deg, #1B365D 0%, #0071E3 100%)",
    primaryReverse: "linear-gradient(135deg, #0071E3 0%, #1B365D 100%)",
    subtle: "linear-gradient(135deg, #1B365D 0%, #2a4a7a 50%, #0071E3 100%)",
    horizontal: "linear-gradient(90deg, #1B365D 0%, #0071E3 100%)",
    radial: "radial-gradient(circle at center, #0071E3 0%, #1B365D 100%)",
  },
  logos: {
    emblemWhite: "https://customer-assets.emergentagent.com/job_a9be1f67-2b09-4dec-b876-bd68a994a515/artifacts/cptkpnkn_Enable%20Healthcare%20emblem_White.png",
    emblemBlue: "https://customer-assets.emergentagent.com/job_a9be1f67-2b09-4dec-b876-bd68a994a515/artifacts/yxxx8siu_Enable%20Healthcare%20emblem_BLUE.png",
    wordmarkBlue: "https://customer-assets.emergentagent.com/job_a9be1f67-2b09-4dec-b876-bd68a994a515/artifacts/2ljnfsch_Enable%20Healthcare%20emblem_wordmark_BLUE.png",
    wordmarkWhite: "https://customer-assets.emergentagent.com/job_a9be1f67-2b09-4dec-b876-bd68a994a515/artifacts/eph8ezx9_Enable%20Healthcare%20emblem_word_White.png",
  },
  font: "Helvetica, Arial, sans-serif",
};

export const BRAND_COLOR_PRESETS = [
  { name: "Primary Blue", value: "#1B365D" },
  { name: "Pop Blue", value: "#0071E3" },
  { name: "White", value: "#FFFFFF" },
  { name: "Dark Navy", value: "#0f2240" },
  { name: "Light Blue", value: "#e8f0fe" },
  { name: "Slate", value: "#64748b" },
];
